import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { HTTP_HEADERS } from '@improver/core';
import { LoggedUserService } from '@improver/infrastructure/auth-data-layer';
import { Observable } from 'rxjs';
import { isInstanceRequest } from './interceptors.utils';

@Injectable()
export class InstanceInterceptor implements HttpInterceptor {
  private readonly loggedUserService: LoggedUserService = inject(LoggedUserService);

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return isInstanceRequest(request.url) ? next.handle(this.getInstanceId(request)) : next.handle(this.removeInstanceIdHeader(request));
  }

  private getInstanceId(request: HttpRequest<any>): HttpRequest<any> {
    const { instanceId } = this.loggedUserService.getUserDataForRequest();

    if (instanceId) {
      return request.clone({
        setHeaders: {
          [HTTP_HEADERS.INSTANCE_ID]: instanceId,
        },
      });
    }

    return request;
  }

  private removeInstanceIdHeader(request: HttpRequest<any>): HttpRequest<any> {
    return request.clone({ headers: request.headers.delete(HTTP_HEADERS.INSTANCE_ID) });
  }
}
